import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class RedirectService {

    private readonly startingSeconds = 6;
    /**
     * A countdown may only run ONCE, multiple callers (request load, hub updates, completed actions)
     * can all try to start the redirect for the same request
     */
    private countdownIsRunning = false;

    private readonly redirectCountdownSubject = new BehaviorSubject<number | null>(null);
    private readonly redirectUrlSubject = new BehaviorSubject<string | null>(null);

    readonly redirectCountdown$ = this.redirectCountdownSubject.asObservable();
    readonly redirectUrl$ = this.redirectUrlSubject.asObservable();

    startRedirect(toUrl: string): void {
        // do NOT restart (or double up) a countdown that is already ticking
        if (this.countdownIsRunning) {
            return;
        }
        this.countdownIsRunning = true;
        let secondsLeft = this.startingSeconds;
        this.redirectUrlSubject.next(toUrl);
        this.redirectCountdownSubject.next(secondsLeft);

        const interval = setInterval(() => {
            secondsLeft--;
            this.redirectCountdownSubject.next(secondsLeft);
            if (secondsLeft <= 0) {
                clearInterval(interval);
                this.countdownIsRunning = false;
                this.go(toUrl);
            }
        }, 1000);
    }

    go(url: string): void {
        const httpUrl = /^https?:\/\//i.test(url) ? url : 'https://' + url;
        window.location.href = httpUrl;
    }
}
